import { baseUrl } from '@percent/cause-dashboard/services/apiPaths'
import { PBPResponse } from '@percent/cause-dashboard/services/types/pbpResponses.types'
import {
  Candidate,
  CandidateDetails,
  CandidateDocument,
  GetCandidatesParams,
  GetCandidateDetailsParams,
  grantsServiceCapabilities,
  UploadCandidateDocumentsParams,
  GetCandidateFormParams,
  CandidateForm,
  PostCandidateFormParams,
  UploadCandidateDocumentsResponse,
  PostCandidateBankDetailsParams,
  TaskSubmission,
  GetFormSubmissionsParams,
  NonprofitTask,
  UpdateTaskAssigneeParams
} from './grantsService.types'

export const grantsService = ({ percentClient }: grantsServiceCapabilities) => ({
  getCandidate: ({ candidateId, locale }: GetCandidateDetailsParams) =>
    percentClient.get<PBPResponse<CandidateDetails>>(`${baseUrl}grants/candidates/${candidateId}`, {
      params: { locale }
    }),
  getCandidates: ({ locale }: GetCandidatesParams = {}) =>
    percentClient.get<PBPResponse<Candidate[]>>(`${baseUrl}grants/candidates`, {
      params: { locale }
    }),
  uploadCandidateDocuments: ({ candidateId, formData }: UploadCandidateDocumentsParams) =>
    percentClient.post<UploadCandidateDocumentsResponse>(
      `${baseUrl}grants/candidates/${candidateId}/documents`,
      formData
    ),
  getCandidateDocuments: ({ candidateId }: { candidateId: string }) =>
    percentClient.get<PBPResponse<CandidateDocument[]>>(`${baseUrl}grants/candidates/${candidateId}/documents`),
  getMyTasks: ({ candidateId, locale }: { candidateId: string; locale?: string }) =>
    percentClient.get<PBPResponse<NonprofitTask[]>>(`v1/grants/candidates/${candidateId}/tasks`, {
      params: { locale }
    }),
  getCandidateForm: ({ programId, candidateId, formId, locale }: GetCandidateFormParams) =>
    percentClient.get<PBPResponse<CandidateForm>>(
      `${baseUrl}grants/programs/${programId}/candidates/${candidateId}/forms/${formId}`,
      {
        params: { locale }
      }
    ),
  postCandidateForm: ({ programId, candidateId, ...payload }: PostCandidateFormParams) =>
    percentClient.post(`${baseUrl}grants/programs/${programId}/candidates/${candidateId}/form-submissions`, payload),
  postCandidateBankDetails: ({ programId, candidateId, taskId, payload }: PostCandidateBankDetailsParams) =>
    percentClient.post(
      `${baseUrl}grants/programs/${programId}/candidates/${candidateId}/tasks/${taskId}/bank-details`,
      payload.formData
    ),
  getCandidateFormSubmissions: ({ programId, candidateId }: GetFormSubmissionsParams) =>
    percentClient.get<PBPResponse<TaskSubmission[]>>(
      `${baseUrl}grants/programs/${programId}/candidates/${candidateId}/form-submissions`
    ),
  updateTaskAssignee: (params: UpdateTaskAssigneeParams) => percentClient.put(`${baseUrl}grants/task-assignees`, params)
})
